module.exports = __webpack_public_path__ + "assets/alert-8e141ee34dd9edfa658fb2e656b31322.svg";